import React from "react";
import ModalBasic from "../ModalBasic";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import { HEADER } from "../../utils/Utils";
import { requestGet } from "../../api/coreInstance";

export default function ModalOutlet({
  showModal,
  setShowModal,
  modalOutletDetails,
  inputOutlet,
  setInputOutlet,
  functionAdd,
  functionEdit,
}) {
  const loadPostalCode = async (search, callback) => {
    if (search.length > 1) {
      await requestGet(`/v2/collection/postalCode/data?query=${search}&length=0`)
        .then((res) => {
          callback(
            res.data.data.map((option) => ({
              ...option,
              label: option.postal_code,
              value: option.postal_code,
            }))
          );
        })
        .catch((error) => console.error(error));
    }
  };

  const requestLocationPermission = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setInputOutlet((prevState) => ({
            ...prevState,
            longitude: position.coords.longitude,
            latitude: position.coords.latitude,
          }));
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  function handleChange(e) {
    setInputOutlet((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const CustomOption = ({ innerProps, label, data }) => (
    <div
      className="px-4 py-2 hover:bg-blue-300 hover:text-blue-400"
      {...innerProps}
    >
      {label}
      <p className="text-xs text-gray-500">Kelurahan: {data.kelurahan}</p>
    </div>
  );

  return (
    <>
      {/* Modal ADD Outlet */}
      <ModalBasic
        name="add_outlet_modal"
        modalOpen={showModal}
        setModalOpen={setShowModal}
        title={modalOutletDetails.title}
        enClose={true}
      >
        <div className="px-5 pt-4 pb-1">
          <div className="space-y-3">
            <input
              name="outlet_kartini_name"
              placeholder="Outlet Name"
              className="form-input w-full h-12"
              type="text"
              value={inputOutlet.outlet_kartini_name ?? ""}
              onChange={(e) => handleChange(e)}
            />
            <AsyncSelect
              name="postal_code"
              className="col-span-full sm:col-span-2"
              // components={animatedComponent}
              components={{
                Option: CustomOption, // Gunakan komponen custom untuk menampilkan setiap opsi
              }}
              cacheOptions
              value={
                _.isEmpty(inputOutlet.postal_code)
                  ? null
                  : {
                      label: inputOutlet.postal_code,
                      value: inputOutlet.postal_code,
                    }
              }
              placeholder="Postal Code"
              loadOptions={loadPostalCode}
              onChange={(option) => {
                if (!_.isEmpty(option)) {
                  setInputOutlet((prevState) => ({
                    ...prevState,
                    kecamatan: option.kecamatan,
                    kelurahan: option.kelurahan,
                    city: option.city_kabupaten,
                    province: option.province,
                    postal_code: option.postal_code,
                  }));
                }
              }}
            />
            <div className="flex w-full space-x-2">
              <input
                name="kelurahan"
                placeholder="Kelurahan"
                className="form-input w-full h-12"
                type="text"
                value={inputOutlet.kelurahan ?? ""}
                disabled
              />
              <input
                name="kecamatan"
                placeholder="Kecamatan"
                className="form-input w-full h-12"
                type="text"
                value={inputOutlet.kecamatan ?? ""}
                disabled
              />
            </div>
            <div className="flex w-full space-x-2">
              <input
                name="city"
                placeholder="Kota"
                className="form-input w-full h-12"
                type="text"
                value={inputOutlet.city ?? ""}
                disabled
              />
              <input
                name="province"
                placeholder="Provinsi"
                className="form-input w-full h-12"
                type="text"
                value={inputOutlet.province ?? ""}
                disabled
              />
            </div>
            <div className="flex w-full space-x-2">
              <input
                name="outlet_kartini_name"
                placeholder="Long Lat"
                className="form-input w-full h-12"
                type="text"
                value={`${inputOutlet.longitude ?? ""}, ${
                  inputOutlet.latitude ?? ""
                }`}
                disabled
              />
              <button
                className={`btn-xs bg-[#ED64BD] disabled:bg-gray-400 text-white`}
                onClick={() => requestLocationPermission()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                  />
                </svg>
              </button>
            </div>
            <textarea
              name="address"
              id="feedback"
              className="form-textarea w-full focus:border-gray-300"
              rows="3"
              placeholder="Alamat"
              onChange={(e) => handleChange(e)}
              value={inputOutlet.address ?? ""}
            >
              {inputOutlet.address ?? ""}
            </textarea>
          </div>
        </div>
        {/* Modal footer */}
        <div className="px-5 py-4">
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className="btn-sm border-gray-200 hover:border-gray-300 text-gray-600"
              onClick={(e) => {
                e.stopPropagation();
                setShowModal(false);
                setInputOutlet({});
              }}
            >
              Close
            </button>
            <button
              className="btn-sm bg-[#4CA6F8] text-white disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
              onClick={(e) => {
                e.stopPropagation();
                if (modalOutletDetails.type === "Add") {
                  functionAdd();
                } else if (modalOutletDetails.type === "Edit") {
                  functionEdit(inputOutlet);
                }
              }}
              disabled={
                !inputOutlet.outlet_kartini_name ||
                !inputOutlet.address ||
                !inputOutlet.postal_code
              }
            >
              {modalOutletDetails.title}
            </button>
          </div>
        </div>
      </ModalBasic>
    </>
  );
}
